import moment from 'moment';
import React, { useEffect, useState } from 'react';
import isBlank from 'utils/object';
import { AttachDownloadList } from './AttachDownload';
import prettyBytes from 'utils/prettyBytes';
import { financial } from 'utils/number';
import { Button, Popover } from '@beehive/components';
import { adaptMpcExternalOuterPath } from '@mpc/common/src/utils/axios';

export const getContent = (v: string, isTime = false) => {
  const isEmpty = isBlank(v);
  if (isEmpty) return '--';
  if (isTime) {
    return moment(v).format('YYYY-MM-DD');
  } else {
    return v;
  }
};

export const MockInputShow = (props: { text: string, email?: string }) => {
  const { text, email = "" } = props;
  return (
    <span title={email} style={{ height: '32px', lineHeight: '32px' }}>
      {isBlank(text) ? '--' : text}
    </span>
  );
};

export const ProductNameShow = (props: any) => {
  const { id, options = [] } = props;
  const [name, setName] = useState('');
  useEffect(() => {
    if (options.length < 1) return;
    const flatProductAry: any[] = [];
    options.forEach((v: any) => {
      if (v.children && Array.isArray(v.children)) {
        v.children.forEach((v2: any) => {
          flatProductAry.push(v2);
        });
      }
    });
    setName(
      flatProductAry
        .filter((v: any) => id === v.value)
        .map((v: any) => v.name)
        .join(',')
    );
  }, [options]);
  return <MockInputShow text={name} />;
};

export const SelectShow = (props: any) => {
  const { id, options = [] } = props;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  useEffect(() => {
    if (options.length < 1) return;
    let str = '';
    let em = ""
    if (Array.isArray(id)) {
      str = options
        .filter((v: any) => id.includes(v.value))
        .map((v: any) => v.name)
        .join(',');
      em = options
        .filter((v: any) => id.includes(v.value))
        .map((v: any) => v.email)
        .join(',');
    } else {
      str = options
        .filter((v: any) => v.value === id)
        .map((v: any) => v.name)
        .join(',');
      em = options
        .filter((v: any) => v.value === id)
        .map((v: any) => v.name)
        .join(',');
    }
    setName(str);
    setEmail(em);
  }, [id, options]);
  return <MockInputShow text={name} email={email} />;
};

export const MoneyShow = (props: any) => {
  const { value, currency, options = [] } = props;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: 4 }}>{financial(value)}</span>
      <SelectShow id={currency} options={options} />
    </div>
  );
};

export const FileListShow = (props: any) => {
  const { list = [], withPopover = true } = props;

  if (list.length === 0) return <>--</>;

  if (withPopover) {
    return (
      <Popover
        content={
          <AttachDownloadList
            list={list.map((v: any) => ({
              fileName: v.name,
              size: prettyBytes(v.size),
              link: adaptMpcExternalOuterPath(`/api/outsource/v2/java_proxy/attachments/${v.attach_id}?download=attachment`),
              id: v.attach_id,
            }))}
          />
        }
      >
        <span
          style={{
            width: 'auto',
            height: '32px',
            display: 'inline-flex',
            alignItems: 'center',
            alignSelf: 'flex-start',
          }}
        >
          <Button link>查看附件</Button>
        </span>
      </Popover>
    );
  }

  return (
    <AttachDownloadList
      list={list.map((v: any) => ({
        fileName: v.name,
        size: prettyBytes(v.size),
        link: adaptMpcExternalOuterPath(`/api/outsource/v2/java_proxy/attachments/${v.attach_id}?download=attachment`),
        id: v.attach_id,
      }))}
    />
  );
};

export const TimeShow = (props: any) => {
  const { value, format = 'YYYY-MM-DD'  } = props;
  if (!value) return <>--</>;
  return <MockInputShow text={moment(value).format(format)} />;
};
